export default __webpack_public_path__ + "static/media/asset-1@3x.ae95c9fa.png";